// What an MFA API sign-in's reason code means (authn-service do-authenticationV4
// with credentialType APP, decided by app policies). One mapping for the
// Sign-in logs and the Applications dashboard's Recent denials.
export const MFA_API_REASONS = {
  push_approved: "Approved on the phone",
  push_denied: "Denied on the phone",
  push_expired: "Not answered",
  no_policy: "No policy",
  policy_block: "Blocked by policy",
  policy_allow: "Allowed without MFA",
  not_in_directory: "Unknown user",
  rate_limited: "Too many requests",
};

// The label for an MFA API reason code, or "" when the code isn't one.
export const mfaApiReasonLabel = (reason) => MFA_API_REASONS[String(reason || "").trim().toLowerCase()] || "";
